import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchAllDesg = createAsyncThunk(
    'getAllDesg/fetchAllDesg',
    async (_, { rejectWithValue }) => {
        try {
            const url = api.credentials.designation;
            const response = await axiosPrivate.get(url)
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || "Unable to connect to server");
        }
    }
)

const designationSlice = createSlice({
    name: 'designation',
    initialState: {
        designation: [],
        status: 'idle',
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builders) => {
        builders
            .addCase(fetchAllDesg.pending,
                (state) => {
                    state.status = 'loading';
                    state.loading = true;
                    state.error = null;
                })
            .addCase(fetchAllDesg.fulfilled,
                (state, action) => {
                    state.status = 'succeeded';
                    state.loading = false;

                    // following data should stay all caps
                    const exceptions = ["UI", "UX", "CTO", "CEO", "COO", "HR", "AI", "II", "III", "SRE", "QA"];

                    //state.designation = action.payload.map(item => {
                    state.designation = action.payload
                        .filter(item => typeof item === "string" || item.delete !== true)
                        .map(item => {
                            const rawValue = typeof item === 'string' ? item : (item.name || "");

                            const cleanValue = rawValue
                                .replace(/_/g, ' ')
                                .replace(/[^a-zA-Z0-9 ]/g, '')
                                .replace(/\s+/g, ' ')
                                .trim();

                            // Capitalize the first letter of each word
                            const capitalizedValue = cleanValue
                                .split(' ')
                                .map(word => {
                                    if (exceptions.includes(word.toUpperCase())) {
                                        return word.toUpperCase();
                                    }
                                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                                })
                                .join(' ');
                            // Return the object with the cleaned value
                            return typeof item === 'string'
                                ? capitalizedValue
                                : { ...item, name: capitalizedValue };
                        });
                })
            .addCase(fetchAllDesg.rejected,
                (state, action) => {
                    state.status = 'failed';
                    state.loading = false;
                    state.error = action.payload;
                }
            )
    }
})

export default designationSlice.reducer;